import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { getDefaultRouteForRoles } from '../../config/utility';

const AuthenticatedHomeRedirect = () => {
  const { roles } = useContext(UserContext);

  return <Navigate to={getDefaultRouteForRoles(roles)} replace />;
};

export default AuthenticatedHomeRedirect;
